import {
  DAILY_SALES_REPORT_ADMIN,
  DAILY_SALES_REPORT_DISTRIBUTOR,
  DAILY_SALES_REPORT_GET_RETAILER,
  DAILY_SALES_REPORT_RETAILER,
   DAILY_SALES_REPORT_ASM,
  GET_ADMIN_VOUCHER_SEARCH_REPORT,
  GET_RETAILER_VOUCHER_SEARCH_REPORT,
  GET_BUNDLE_SALE_REPORT,
  GET_WEEKLY_TOTAL_ACTIVATION,
  GET_WEEKLY_ADMIN_WISE_SALES,
  GET_WEEKLY_BUNDLE_PERFORMANCE,
  GET_WEEKLY_CHURN_PERFORMANCE,
  GET_WEEKLY_MONTH_END_FORECAST,
  GET_BUNDLE_SALE_REPORT_AM
} from 'redux/admin-constants';

const initialState = {
  dailySaleAdmin: [],
  dailySaleASM: [],
  dailySaleDistributor: [],
  dailySaleRetailer: [],
  getRetailer: [],
  getAdminVoucher: [],
  getRetailerVoucher: [],
  getBundleSale: [],
  weeklyTotalActivation: [],
  weeklyAdminWiseSales: [],
  weeklyBundlePerformance: [],
  weeklyChurnPerformance: [],
  weeklyMonthEndForecast: [],
  getBundleSaleAM: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case DAILY_SALES_REPORT_ADMIN: {
      return {
        ...state,
        dailySaleAdmin: payload,
      };
    }

    case DAILY_SALES_REPORT_ASM: {
      return {
        ...state,
        dailySaleASM: payload,
      };
    }

    case DAILY_SALES_REPORT_DISTRIBUTOR: {
      return {
        ...state,
        dailySaleDistributor: payload,
      };
    }

    case DAILY_SALES_REPORT_GET_RETAILER: {
      return {
        ...state,
        getRetailer: payload,
      };
    }

    case DAILY_SALES_REPORT_RETAILER: {
      return {
        ...state,
        dailySaleRetailer: payload,
      };
    }

   

    case GET_ADMIN_VOUCHER_SEARCH_REPORT: {
      return {
        ...state,
        getAdminVoucher: payload,
      };
    }

    case GET_RETAILER_VOUCHER_SEARCH_REPORT: {
      return {
        ...state,
        getRetailerVoucher: payload,
      };
    }

     case GET_BUNDLE_SALE_REPORT: {
      return {
        ...state,
        getBundleSale: payload,
      };
    }

    case GET_BUNDLE_SALE_REPORT_AM:{
        return {
        ...state,
        getBundleSaleAM: payload,
      };
    }

    case GET_WEEKLY_TOTAL_ACTIVATION: {
      return {
        ...state,
        weeklyTotalActivation: payload,
      };
    }

    case GET_WEEKLY_ADMIN_WISE_SALES: {
      return {
        ...state,
        weeklyAdminWiseSales: payload,
      };
    }

    case GET_WEEKLY_BUNDLE_PERFORMANCE: {
      return {
        ...state,
        weeklyBundlePerformance: payload,
      };
    }

    case GET_WEEKLY_CHURN_PERFORMANCE: {
      return {
        ...state,
        weeklyChurnPerformance: payload,
      };
    }

    case GET_WEEKLY_MONTH_END_FORECAST: {
      return {
        ...state,
        weeklyMonthEndForecast: payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
